import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SkipArrow from './skip-arrow-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SkipArrow {...validProps} />;
}
SvgComponent.iconName = 'skip-arrow-icon';

export const SkipArrowIcon = svgIconWrapper(SvgComponent);
